const CheckMeO2Ppg = () => {
  return (
    <ul className="text-left">
      <li>
        <span>1.</span> Be sure the CheckMeO2 USB cable is connected
        securely to your computer.
      </li>
      <li>
        <span>2</span>
        Be sure the device is fully powered on (press and hold power button if not)
      </li>
    </ul>
  )
}

export default CheckMeO2Ppg
